import { FC } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface PDFPreviewModalProps {
  open: boolean;
  url: string | null;
  onClose: () => void;
}

const PDFPreviewModal: FC<PDFPreviewModalProps> = ({ open, url, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Document Preview
        <IconButton
          aria-label="close preview"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0, height: '80vh' }}>
        {url && (
          <iframe
            src={url}
            title="PDF Preview"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PDFPreviewModal;
